import { render, staticRenderFns } from "./edit-manage-info.vue?vue&type=template&id=11548898&scoped=true"
import script from "./edit-manage-info.vue?vue&type=script&lang=js"
export * from "./edit-manage-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11548898",
  null
  
)

export default component.exports